import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ENGINE_FEATURE_KEY } from '@blaze-runtime/engine-data-access';

import { type HistoryEngineState } from './editor-history.state';

/**
 * Reads the `engine` slice as the undo/redo handlers write it. `history` is absent unless this
 * library's engine-state extension is registered, so every reader below tolerates its absence.
 */
export const getHistoryEngineState = createFeatureSelector<HistoryEngineState>(ENGINE_FEATURE_KEY);

export const getIsRestoring = createSelector(
  getHistoryEngineState,
  (state) => !!state.history?.isRestoring,
);

export const getHasPast = createSelector(
  getHistoryEngineState,
  (state) => !!state.history?.past.length,
);

export const getHasFuture = createSelector(
  getHistoryEngineState,
  (state) => !!state.history?.future.length,
);
